<script src="index.js"></script>
<template>
  <div :class="boxShadow ? 'header on' : 'header'">
    <div style="margin: auto;padding-left: 24px;min-width: 1440px;box-sizing: border-box;height: 64px;">
      <h1 :class="{'logo': true, 'sdcqjy': shortName === '山东省技术成果交易中心'}">
        <router-link v-bind:to="{path: '/'}" style="display: inline-block"><img :src="logoUrl" alt="">
        </router-link>
      </h1>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        router>
        <template v-for="(item, index) in routerNav">
          <template v-if="item.children !== undefined && item.children.length > 1 && item.meta.isSingle !== true">
            <el-submenu :index="item.path" v-bind:key="index" v-if="item.hidden !== true">
              <template slot="title">{{ item.meta.title }}</template>
              <template v-for="(itemChild, indexChild) in item.children">
                <template v-if="!contractState">
                  <el-menu-item v-if="itemChild.hidden !== true" @click="contractStateFalse"
                                :key="index + '-' + indexChild" v-html="itemChild.meta.title"></el-menu-item>
                </template>
                <template v-else>
                  <template v-if="(itemChild.path === '/industry/index' && !roles.industryIndex) || (itemChild.path === '/regionalmap/index' && !roles.regionalmapIndex) || (itemChild.path === '/industry/chain' && !roles.industryChain) || (itemChild.path === '/company/merge/index' && !roles.CompanyMerge)">
                    <el-menu-item v-if="itemChild.hidden !== true" @click="contractStateFalse"
                                  :key="index + '-' + indexChild" v-html="itemChild.meta.title"></el-menu-item>
                  </template>
                  <template v-else>
                    <el-menu-item :index="itemChild.path" v-if="itemChild.hidden !== true"
                                  :key="index + '-' + indexChild" v-html="itemChild.meta.title"></el-menu-item>
                  </template>
                </template>
              </template>
            </el-submenu>
          </template>
          <template v-else-if="item.path === '/hotTool'">
            <el-submenu :index="item.path" v-bind:key="index" v-if="item.hidden !== true && (roles.merchants || roles.ListingLibrary || roles.financingOverview || roles.fundingLibrary || roles.chainSearch || roles.CompanyRelationship)">
              <template slot="title">{{ item.meta.title }}</template>
              <template v-for="(itemChild, indexChild) in item.children">
                <el-menu-item :index="itemChild.path" v-if="itemChild.hidden !== true && ((roles.merchants && itemChild.meta.title === '地图招商') || (roles.ListingLibrary && itemChild.meta.title === '上市事件库') || (roles.financingOverview && itemChild.meta.title === '投资总览') || (roles.fundingLibrary && itemChild.meta.title === '投融资事件库') || (roles.emigrationWarning && itemChild.meta.title === '外迁预警') || (roles.chainSearch && itemChild.meta.title === '链式寻企') || (roles.CompanyRelationship && itemChild.meta.title === '企业关系网络'))"
                              :key="index + '-' + indexChild" v-html="itemChild.meta.title">
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
          <template v-else>
            <template v-if="item.path === '/techindustry'">
              <template v-if="!contractState || !roles.decision">
                <!--<el-menu-item v-if="item.hidden !== true" v-bind:key="index" @click="contractStateFalse"-->
                              <!--v-html="item.meta.title"></el-menu-item>-->
              </template>
              <template v-else>
                <el-menu-item v-if="item.hidden !== true" :index="item.redirect === undefined ? item.path : item.redirect" v-bind:key="index"
                              v-html="item.meta.title"></el-menu-item>
              </template>
            </template>
            <template v-else>
              <el-menu-item v-if="item.hidden !== true" :index="item.redirect === undefined ? item.path : item.redirect" v-bind:key="index"
                            v-html="item.meta.title"></el-menu-item>
            </template>
          </template>
        </template>
      </el-menu>
    </div>
    <div class="user-box">
      <el-dropdown class="message">
        <span class="el-dropdown-link"><el-badge is-dot :hidden="unReadMessageNum === 0"><i class="el-icon-bell"></i></el-badge></span>
        <el-dropdown-menu slot="dropdown" class="user-message">
          <ul>
            <li class="on">系统通知</li>
            <li @click="$router.push({name: 'messageList', query: {t: new Date().getTime()}})">查看全部</li>
          </ul>
          <div v-if="messageNewestList.length > 0">
            <el-dropdown-item  @click.native="goDetail(item)" v-for="(item, index) in messageNewestList" :key="index" :class="item.readState == 0 ? '' : 'on'">
              <dl>
                <dt><img :src="item.type == 0 ? require('../../assets/img/message_icon.png') : require('../../assets/img/merge_icon.png')" alt=""></dt>
                <dd>
                  <p class="ellipsis" :title="item.title">{{item.title}}</p>
                  <p>{{item.submitDate}}</p>
                </dd>
              </dl>
            </el-dropdown-item>
          </div>
          <p v-else style="color: rgba(70, 70, 70, 0.6);line-height: 120px;text-align: center;font-size: 12px">您暂时没有新消息。</p>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="user">
        <span class="el-dropdown-link"><i></i></span>
        <el-dropdown-menu slot="dropdown" class="user-select">
          <el-dropdown-item @click.native="goUser">个人中心</el-dropdown-item>
          <el-dropdown-item v-if="manualPath" class="books"><a :href="manualPath" target="_blank">操作手册</a></el-dropdown-item>
          <el-dropdown-item @click.native="logout" class="logout">退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog :title="messageNewestDetail.title" :visible.sync="dialogVisible" width="750px" :close-on-press-escape="false" :close-on-click-modal="false" :center="true" custom-class="message-content-head" @close="setMessagePopRead(messageNewestDetail)">
      <div v-html="messageNewestDetail.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false;setMessagePopRead(messageNewestDetail)">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {messageApi} from '@/api/workbench/message';
import {taskApi} from '@/api/workbench/task';
import { overallApi } from '@/api/merge/overall';
export default {
  name: 'HeaderMain',
  data () {
    return {
      dialogVisible: false,
      roles: {
        industryIndex: false,
        regionalmapIndex: false,
        industryChain: false,
        decision: false,
        merchants: false,
        ListingLibrary: false,
        financingOverview: false,
        fundingLibrary: false,
        emigrationWarning: false,
        chainSearch: false,
        CompanyMerge: false,
        CompanyRelationship: false
      },
      manualPath: undefined,
      routerNav: [],
      messageNewestList: [],
      unReadMessageNum: 0,
      contractState: true,
      boxShadow: false,
      logoUrl: '',
      messageNewestDetail: {},
      intervalClear: null,
      shortName: ''
    };
  },
  computed: {
    ...mapGetters([
      'permission_routes'
    ]),
    activeIndex () {
      const route = this.$route;
      const {meta, path} = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      this.fullscreen(path);
      return path;
    }
  },
  watch: {
    $route (to, from) {
      this.$emit('goscrolltop');
      this.fullscreen(to.path);
      if (to.path == '/company/contrast' || to.path == '/company/detail' || to.path == '/industry/chain/detail' || to.path == '/company/industry' || to.path == '/industry/index' || to.path == '/industry/chain/index' || to.name == 'IndustryList' || to.name == 'TalentPatent' || to.name == 'CompanyDetail' || to.name == 'ChainSearchIndex' || to.path == '/company/merge' || to.path == '/company/guquan' || this.$route.path == '/talent/detail') {
        this.boxShadow = false;
      } else {
        this.boxShadow = true;
      }
      // 如果改变路由（第一次进入页面）调用循环消息
      clearInterval(this.intervalClear);
      this.intervalClear = null;
      this.intervalMessage();
      // 如果是消息详情页面，调一下简要消息防止有未读消息
      if (to.path == '/message/detail' || to.path == '/company/merge') this.messageBrief();
    }
  },
  mounted () {
    this.shortName = this.$store.getters.shortName;
    // 如果页面是再次刷新调用循环消息
    if (window.performance.navigation.type === 1) {
      clearInterval(this.intervalClear);
      this.intervalClear = null;
      this.intervalMessage();
    } else if (window.performance.navigation.type === 0) {
      clearInterval(this.intervalClear);
      this.intervalClear = null;
      this.intervalMessage();
    }
    if (this.$route.path == '/company/contrast' || this.$route.path == '/company/detail' || this.$route.path == '/company/industry' || this.$route.path == '/industry/index' || this.$route.path == '/industry/chain/index' || this.$route.name == 'IndustryList' || this.$route.name == 'TalentPatent' || this.$route.name == 'CompanyDetail' || this.$route.name == 'ChainSearchIndex' || this.$route.path == '/company/merge' || this.$route.path == '/company/guquan' || this.$route.path == '/talent/detail') {
      this.boxShadow = false;
    } else {
      this.boxShadow = true;
    }
    this.logoUrl = this.$store.getters.logoUrl;
    this.manualPath = this.$store.getters.manualPath || undefined;
    document.title = this.$store.getters.shortName;
    this.$nextTick(() => {
      this.routerNav = this.permission_routes;

      // 替换网页标签
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = this.$store.getters.icoUrl || undefined;
      document.getElementsByTagName('head')[0].appendChild(link);
      this.messageBrief();
    });
    this.fullscreen(this.$route.path);
    let _this = this;
    if (this.$store.getters.contract === '') {
      _this.contractState = false;
    } else {
      _this.contractState = true;
    }
    let roles = JSON.parse(this.$store.getters.roles).authorities || [];
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === 'area_map') {
        this.roles.regionalmapIndex = true;
      } else if (roles[i] === 'industry_map') {
        this.roles.industryIndex = true;
      } else if (roles[i] === 'industry_chain') {
        this.roles.industryChain = true;
      } else if (roles[i] === 'decision') {
        this.roles.decision = true;
      } else if (roles[i] === 'merchants') {
        this.roles.merchants = true;
      } else if (roles[i] === 'listed_library') {
        this.roles.ListingLibrary = true;
      } else if (roles[i] === 'financing_overview') {
        this.roles.financingOverview = true;
      } else if (roles[i] === 'funding_library') {
        this.roles.fundingLibrary = true;
      } else if (roles[i] === 'migration_warning') {
        this.roles.emigrationWarning = true;
      } else if (roles[i] === 'chain_search') {
        this.roles.chainSearch = true;
      } else if (roles[i] === 'company_relationship') {
        this.roles.CompanyRelationship = true;
      } else if (roles[i] === 'merge') {
        this.roles.CompanyMerge = true;
      }
    }
  },
  methods: {
    // 循环消息
    intervalMessage () {
      this.taskMessageNewest();
      clearInterval(this.intervalClear);
      this.intervalClear = null;
      this.intervalClear = setInterval(() => {
        this.taskMessageNewest();
      }, 10000);
    },
    // 消息详情
    goDetail (row) {
      if (row.type === 0) {
        if (row.readState === 1) {
          this.$router.push({name: 'messageDetail', query: {id: row.id, t: new Date().getTime()}});
        } else {
          messageApi.messageRead([row.id]).then((response) => {
            this.$router.push({name: 'messageDetail', query: {id: row.id, t: new Date().getTime()}});
          });
        }
      } else {
        overallApi.getTaskTime(row.ext.taskId).then(() => {
          if (row.readState === 1) {
            this.$router.push({name: 'OverallAnalysis', query: {taskId: row.ext.taskId, mergeType: row.ext.taskType === 0 ? 'overall' : 'compare', t: new Date().getTime()}});
          } else {
            messageApi.messageRead([row.id]).then((response) => {
              taskApi.taskRead([row.ext.taskId]).then((response) => {
                this.$router.push({name: 'OverallAnalysis', query: {taskId: row.ext.taskId, mergeType: row.ext.taskType === 0 ? 'overall' : 'compare', t: new Date().getTime()}});
              });
            });
          }
        }).catch(() => {
          this.$message({message: '该合并任务已被删除！', type: 'error'});
        });
      }
    },

    // 设置弹窗消息已读
    setMessagePopRead(row) {
      messageApi.messageRead([row.id]).then(() => {
        this.messageBrief();
      });
    },

    // 消息弹窗
    taskMessageNewest () {
      messageApi.taskMessageNewest().then((response) => {
        // 消息弹窗 --- 显示消息的最后一条不用全部显示
        // 只要有未读的消息 && 没有弹窗的调用一下简要消息接口
        if (response.length > 0) {
          let isHasMessage = false;
          let isTaskMessage = false;
          for (let i = 0; i < response.length; i++) {
            if (response[i].type === 0) {
              if (response[i].readState === 0) {
                isHasMessage = true;
              }
              if (response[i].ext && !!response[i].ext.isPopUp) {
                this.messageNewestDetail = response[i];
                this.dialogVisible = true;
                return;
              }
            } else {
              isTaskMessage = true;
            }
          }
          if (isHasMessage) {
            this.messageBrief();
          }
          if (isTaskMessage) {
            this.$notify({
              title: '成功',
              message: '您有一条合并成功消息。',
              type: 'success',
              offset: 100,
              duration: 0,
              onClick: () => {
                this.$router.push({name: 'messageList'});
              }
            });
            this.messageBrief();
          }
        }
      })
    },

    // 简要消息
    messageBrief () {
      messageApi.messageBrief().then((response) => {
        this.messageNewestList = response.messages || [];
        this.unReadMessageNum = response.unReadMessageNum || 0;
        // 如果第一个任务是已读状态，那么弹窗就消失
        if (this.messageNewestList.length > 0) {
          let taskList = [];
          for (let i = 0; i < this.messageNewestList.length; i++) {
            if (this.messageNewestList[i].type === 1) {
              taskList.push(this.messageNewestList[i]);
            }
          }
          if (taskList.length > 0) {
            if (taskList[0].readState == 1) {
              this.$notify.closeAll();
            }
          }
        }
      })
    },
    contractStateFalse () {
      this.$message({
        showClose: true,
        offset: 100,
        message: '您暂时没有开通该功能的权限，请联系管理员',
        type: 'error'
      });
    },
    async logout () {
      clearInterval(this.intervalClear);
      this.intervalClear = null;
      await this.$store.dispatch('user/logout');
      this.$router.push('/login');
    },
    goUser () {
      this.$router.push('/user');
    },
    resolvePath (path, routePath) {
      if (path !== '/') {
        return path + '/' + routePath;
      }
      return routePath;
    },
    fullscreen (path) {
      if (path === '/regionalmap/index' || path === '/regionalmap/contrast') {
        $('body').addClass('regionalMap_body');
      } else {
        $('body').removeClass('regionalMap_body');
      }
      if (path === '/company/marketing' || path === '/company/riskControl') {
        $('body').addClass('no_scrollbar');
      } else {
        $('body').removeClass('no_scrollbar');
      }
    }
  }
};
</script>
<style lang="scss">
.user-select {
  .el-dropdown-menu__item {
    white-space: nowrap;
    padding-left: 44px;
    padding-right: 20px;

    &:nth-child(1) {
      background: url("../../assets/img/user_center.svg") 20px center no-repeat;
      border-bottom: 1px solid #f0f0f0;
    }

    &.books {
      background: url("../../assets/img/prbook.svg") 20px center no-repeat;
      border-bottom: 1px solid #f0f0f0;
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
        color: $mainColor;
        a {
          color: $mainColor !important;
        }
      }
      a {
        color: #606266!important;
      }
    }

    &.logout {
      background: url("../../assets/img/logout.svg") 20px center no-repeat;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      color: $mainColor;
    }
  }
}
.user-message{
  width: 320px;
  padding-top: 0;
 &>ul{
   overflow: hidden;
   border-bottom: 1px solid #EFF1F8;
   height: 40px;
   line-height: 40px;
   padding: 0 20px;
   margin-bottom: 10px;
   li:not(:last-child){
     float: left;
     width: 56px;
     font-size: 14px;
     color: #464646;
     margin-right: 10px;
     cursor: pointer;
   }
   li.on{
     font-weight: bolder;
     position: relative;
     &:before{
       position: absolute;
       bottom: 0;
       left: 0;
       height: 2px;
       width: 100%;
       content: '';
       background: #6088CD;
     }
   }
   li:last-child{
     float: right;
     font-size: 12px;
     color: #0091FF;
     cursor: pointer;
   }
 }
 .el-dropdown-menu__item{
    margin: 0 14px;
    padding: 0;
    .el-dropdown-menu__item:not(.is-disabled):hover, .el-dropdown-menu__item:focus{
      background: #B4BBC9;
    }
    &.on{
      opacity: 0.8;
    }
    dl{
      display: flex;
      padding: 10px 4px;
      dt{
        img{
          width: 36px;
          height: 36px;
        }
      }
      dd{
        margin-left: 10px;
        width: calc(100% - 36px);
        font-size: 12px;
        color: #464646;
        line-height: 22px;
      }
    }
    &.on{
      dd{
        color: rgba(70, 70, 70, 0.6);
      }
    }
  }
}
.message-content-head{
  border-radius: 8px;
  .el-dialog__title{
    font-size: 18px;
    color: rgb(62, 78, 131);
  }
  .el-dialog__header{
    padding: 60px !important;
    padding-bottom: 0 !important;
  }
  .el-dialog__footer{
    padding-bottom: 60px !important;
  }
  &>.el-dialog__body{
    padding: 24px 60px 30px 60px !important;
    box-sizing: border-box;
    &>div{
      all: initial;
      &>*{
        margin: 1em 0;
      }
    }
    img{
      width: 100%;
      height: auto;
    }
  }
}
.user-box {
  height: 40px;
  .search-box {
    width: 360px;
  }

  .el-input__suffix {
    font-size: 20px;
  }

  .user {
    margin-left: 30px;
    width: 36px;
    background: url("../../assets/img/user_header.svg") center no-repeat;
    background-size: contain;
    cursor: pointer;

    i {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .message{
    width: 20px;
    cursor: pointer;
    height: 40px;
    i{
      font-size: 18px;
      font-weight: bolder;
    }
    .el-badge{
      top: 10px;
    }
  }
}
body>.el-menu--horizontal .el-menu--popup{
  min-width: 150px;
  .el-menu-item{
    line-height: 40px;
    height: 40px;
    font-size: 14px;
    padding: 0;
    &.is-active{
      font-size: 14px;
    }
  }
}
</style>
<style lang="scss" scoped>
.header {
  height: 64px;
  z-index: 5000;
  background: #fff;
  position: relative;
  &.on{
    box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
  }

  .user-box {
    position: absolute;
    z-index: 3;
    top: 12px;
    right: 24px;
    display: flex;
    .el-input {
      font-size: 14px;
    }

    .el-input__inner {
      border: 1px solid #E6E6E6;
    }
  }
}

.logo {
  float: left;
  margin-right: 62px;
  margin-top: 12px;
  &.sdcqjy{
    position: relative;
    &:after{
      content: '山东省技术成果交易中心';
      position: absolute;
      top: 0;
      line-height: 40px;
      color: #000;
      font-weight: bold;
      font-size: 16px;
      white-space: nowrap;
      left: 46px;
    }
  }
}

.el-menu--horizontal {
  float: left;
  border: 0!important;
  .el-submenu{
    padding: 0 30px;
    color: #262626;
    &:hover{
      background: rgba(0, 0, 0, 0.1) !important;
    }
    &.is-active{
      >>> .el-submenu__title{
        font-size: 18px;
        color: $mainColor!important;
      }
      >>> .el-submenu__icon-arrow{
        color: $mainColor!important;
      }
    }
    >>> .el-submenu__title{
      padding: 0;
      text-align: center;
      line-height: 64px;
      height: 64px;
      font-size: 16px;
      border: 0!important;
      color: #262626!important;
      background: none!important;
    }
    >>> .el-submenu__icon-arrow{
      color: #262626;
    }
  }
  .el-menu-item {
    padding: 0 30px;
    text-align: center;
    line-height: 64px;
    height: 64px;
    font-size: 16px;
    border: 0!important;
    color: #262626!important;

    &.is-active {
      font-size: 18px;
      color: $mainColor!important;
      &.noActive{
        font-size: 16px;
        color: #262626!important;
      }
    }

    &:hover {
      background: rgba(0, 0, 0, 0.1) !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/layout/components/header.vue